import React, { useRef, useState } from "react";
import EventIcon from "@mui/icons-material/Event";

import {
  Box,
  Divider,
  Fab,
  Grid,
  Modal,
  Button,
  Pagination,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import AddCircleIcon from "@mui/icons-material/AddCircle";
// import DatePicker from "react-datepicker";
import CurrencyRupeeIcon from "@mui/icons-material/CurrencyRupee";
// import "react-datepicker/dist/react-datepicker.css";
import AddIcon from "@mui/icons-material/Add";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
// import AdapterDateFns from "@mui/lab/AdapterDateFns";
import { useEffect } from "react";

import { getPurchaseDetail } from "./purchaseApi";

import {
  displayDateFormat,
  formatDateFromCustomToStandard,
  getEndOfMonth,
  getFirstDateOfCurrentMonthPayloadFormate,
  getFirstDateOfMonth,
  getLastDateOfCurrentMonthPayloadFormat,
  getLastDateOfMonth,
  getStartOfMonth,
  payloadDateFormat,
} from "../../utils/commonUtils";
import PurchaseAccordian from "./purchaseAccordian";
import PuchaseModal from "./purchaseModal";
import { getPurchase } from "./purchaseCustomApiHandler";
import {
  datePickerOnChange,
  datePickerOnChangeEnd,
} from "./purchaseDateFunctions";
// import { PageSizeCalculate } from "./purFunction";
import { callbackHandlerGetPurchase } from "./purchaseFunctionParamter";
import PurchaseSearchModal from "./purchaseSearchModal";
import DynamicBreadcrumbs from "../../common/Breadcrumb";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";

const Purchase = ({ gridSize, CardComponent, Display }) => {
  const [open, setOpen] = useState(false);
  const [openSearch, setOpenSearch] = useState(false);
  const [search, setSearch] = useState("");
  const [counterSales, setCounterSales] = useState();
  const [pagination, setPagination] = useState({
    page: 1,
    total: 1,
    records: 0,
    pageSize: 15,
  });
  const [numberOfRecords, setNumberOfRecords] = useState(1);

  const [date, setDate] = useState(null);
  const [displayEndDate, setDisplayEndDate] = useState(null);
  const [dateFocused, setDateFocused] = useState(false);
  const [startDateOpen, setStartDateOpen] = useState(false);
  const [endDateOpen, setEndDateOpen] = useState(false);

  const [SelectedStartDate, setSelectedStartDate] = useState(null);

  const [SelectedEndDate, setSelectedEndDate] = useState(null);
  const [startDateFormat, setstartDateFormat] = useState(
    dayjs(getFirstDateOfCurrentMonthPayloadFormate()).format("YYYY-MM-DD")
  );

  const [endDate, setEndDate] = useState(
    dayjs(getLastDateOfCurrentMonthPayloadFormat()).format("YYYY-MM-DD")
  );
  let payload = {
    rawMaterialId: 0,
    quantity: 0,
    amount: 0,
    description: "",
    price: 0,
  };
  const [purchaseItem, setPurchaseItem] = useState(payload);

  const [searchItem, setSearchItem] = useState([]);
  const datePickerRef = useRef();
  const datePickerRef2 = useRef();

  const openDatePicker = () => {
    if (datePickerRef.current) {
      datePickerRef.current.setOpen(true);
    }
  };
  const [totalAmount, setTotalAmount] = useState(0);
  const [totalRecords, setTotalRecords] = useState(0);
  const [purchaseItems, setPurchaseItems] = useState([]);

  const callbackHandlerGetPurchaseob = callbackHandlerGetPurchase(
    getPurchase,
    {
      fromDate: startDateFormat,
      toDate: endDate,
      search: "string",
      page: 1,
      pageSize: pagination.pageSize,
    },
    setNumberOfRecords,
    setPurchaseItems,
    getPurchaseDetail,
    setTotalAmount,
    setTotalRecords
  );
  useEffect(() => {
    callbackHandlerGetPurchaseob.getPurchase.callback({
      ...callbackHandlerGetPurchaseob.getPurchase.parameter,
      param: {
        fromDate: startDateFormat,
        toDate: endDate,
        search: "string",
        page: 1,
        pageSize: pagination.pageSize,
      },
    });
    // getPurchase(
    //   {
    //     fromDate: startDateFormat,
    //     toDate: endDate,
    //     search: "string",
    //     page: 1,
    //     pageSize: 4,
    //   },
    //   setNumberOfRecords,
    //   setPurchaseItems,
    //   getPurchaseDetail, setTotalAmount
    // );
  }, [startDateFormat, endDate]);

  useEffect(() => {
    const start = dayjs(getFirstDateOfCurrentMonthPayloadFormate());
    const end = dayjs(getLastDateOfCurrentMonthPayloadFormat());

    setSelectedStartDate(start);
    setSelectedEndDate(end);
    setDate(start);
    setDisplayEndDate(end.format("YYYY-MM-DD"));
  }, []);

  useEffect(() => {
    console.log("datE ", getFirstDateOfCurrentMonthPayloadFormate());
    callbackHandlerGetPurchaseob.getPurchase.callback({
      ...callbackHandlerGetPurchaseob.getPurchase.parameter,
      param: {
        fromDate: startDateFormat,
        toDate: endDate,
        search: "string",
        page: 1,
        pageSize: pagination.pageSize,
      },
    });
    // getPurchase(
    //   {
    //     fromDate: startDateFormat,
    //     toDate: endDate,
    //     search: "string",
    //     page: 1,
    //     pageSize: 4,
    //   },
    //   setNumberOfRecords,
    //   setPurchaseItems,
    //   getPurchaseDetail, setTotalAmount
    // );
  }, []);
  const handleChange = (event, value) => {
    callbackHandlerGetPurchaseob.getPurchase.callback({
      ...callbackHandlerGetPurchaseob.getPurchase.parameter,
      param: {
        fromDate: startDateFormat,
        toDate: endDate,
        search: "string",
        page: value,
        pageSize: pagination.pageSize,
      },
    });
    // getPurchase(
    //   {
    //     fromDate: startDateFormat,
    //     toDate: endDate,
    //     search: "string",
    //     page: value,
    //     pageSize: 4,
    //   },
    //   setNumberOfRecords,
    //   setPurchaseItems,
    //   getPurchaseDetail,
    //   setTotalAmount
    // );
    setPagination({
      ...pagination,
      page: value,
    });
  };

  return (
    <>
      <Box
        px={{ xs: 2, sm: 4 }}
        pb={4}
        container
        sx={{
          paddingTop: "15px",
          // backgroundColor: "#E3E3FF",
          fontFamily: "'Montserrat', sans-serif",
        }}
      >
        

        {/* <Grid
          container
          alignItems="center"
          justifyContent="center"
          spacing={2}
          sx={{ mt: 2 }}
        >
          <TextField
            fullWidth
            readonly
            onClick={openDatePicker}
            id="date"
            sx={{
              mt: 2,
              width: "60%",
            }}
            value={(date || displayEndDate) ? (date ?? "") + " To " + (displayEndDate ?? "") : null}
            label="Date :"
            onFocus={() => setDateFocused(true)}
            onBlur={() => setDateFocused(false)}
            onChange={(e) => { }}
            InputLabelProps={{
              sx: {
                color: "grey", // your custom styling here
                cursor: "pointer",
                whiteSpace: "nowrap",
              },
              shrink: !!date || !!displayEndDate || dateFocused,
            }}
            InputProps={{
              style: {
                height: "40px",
              },
              endAdornment: (
                <EventIcon
                  sx={{
                    color: (theme) => theme.palette.primary.main,
                    cursor: "pointer",
                  }}
                />
              ),
            }}
          />
          {gridSize && (
            <FileDownloadIcon
              sx={{
                mt: "17px",
                ml: "10px",
                mr: "0px",
                height: "1.4375em",
                cursor: "pointer",
                // m: "16.5px 14px",
              }}
            />
          )}

          <Box
            sx={{
              height: "100%",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          ></Box>

          <DatePicker
            hidden={true}
            selected={SelectedStartDate}
            // maxDate={new Date()}
            onChange={(data) =>
              datePickerOnChange(
                data,
                datePickerRef2,
                setDate,
                setstartDateFormat,
                setSelectedStartDate
              )
            }
            className="custom-datepicker"
            ref={datePickerRef}
            onClickOutside={() => {
              datePickerRef.current.setOpen(false);
            }}
          />

          <DatePicker
            hidden={true}
            selected={SelectedEndDate}
            // minDate={new Date()}
            onChange={(data) =>
              datePickerOnChangeEnd(
                data,
                datePickerRef2,
                setSelectedEndDate,
                setDisplayEndDate,
                setEndDate
              )
            }
            className="custom-datepicker"
            ref={datePickerRef2}
            onClickOutside={() => {
              datePickerRef2?.current?.setOpen(false);
            }}
          />
          <Grid item xs={gridSize ? 2 : 2}>
            <Button
              variant="contained"
              onClick={() => setOpen(true)}
              fullWidth
              sx={{
                height: '40px',
                backgroundColor: '#14008B',
                padding: 0,
                whiteSpace: 'nowrap',
              }}
              endIcon={<AddIcon />}
            >
              Add Purchase
            </Button>
          </Grid>
        </Grid> */}

        <Grid container spacing={2} alignItems="center">
          {/* Date Range TextField */}
          <Grid
            item
            xs={12}
            sm={8}
            lg={10}
            md={9}
            sx={{
              order: { xs: 2, sm: 1 },
              pt: 2,
            }}
          >
            <TextField
              label="Date"
              size="small"
              value={
                SelectedStartDate && SelectedEndDate
                  ? `${SelectedStartDate.format(
                      "DD-MM-YYYY"
                    )} to ${SelectedEndDate.format("DD-MM-YYYY")}`
                  : SelectedStartDate
                  ? `${SelectedStartDate.format("DD-MM-YYYY")}`
                  : ""
              }
              id="datepickerfield"
              placeholder="Select date range"
              InputProps={{
                readOnly: true,
                endAdornment: (
                  <CalendarMonthIcon
                    sx={{
                      cursor: "pointer",
                      mr: 1,
                      fontSize: { xs: "12px", sm: "13px", md: "15px" },
                    }}
                    onClick={() => setStartDateOpen(true)}
                  />
                ),
                sx: {
                  background: "#fff",
                  fontSize: { xs: "12px", sm: "12px", md: "15px" },
                  borderRadius: 1,
                  cursor: "pointer",
                  fontFamily: "'Montserrat', sans-serif",
                  fontWeight: 500,
                  "& fieldset": {
                    border: "none",
                  },
                },
              }}
              onClick={() => setStartDateOpen(true)}
              sx={{ width: "100%", height: "50px" }}
            />

            {/* Hidden Start Date Picker */}
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <DatePicker
                open={startDateOpen}
                onOpen={() => setStartDateOpen(true)}
                onClose={() => setStartDateOpen(false)}
                value={SelectedStartDate}
                onChange={(val) => {
                  datePickerOnChange(
                    val,
                    setStartDateOpen,
                    setDate,
                    setstartDateFormat,
                    setSelectedStartDate,
                    setEndDateOpen
                  );
                }}
                maxDate={SelectedEndDate || undefined}
                slotProps={{
                  popper: {
                    placement: "bottom-end",
                    anchorEl: document.querySelector("#datepickerfield"),
                    sx: {
                      zIndex: 1500,
                      fontSize: { xs: "12px", sm: "13px", md: "15px" },
                    },
                  },
                  textField: { style: { display: "none" } },
                }}
              />
            </LocalizationProvider>

            {/* Hidden End Date Picker */}
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <DatePicker
                open={endDateOpen}
                onOpen={() => setEndDateOpen(true)}
                onClose={() => setEndDateOpen(false)}
                value={SelectedEndDate}
                onChange={(val) => {
                  datePickerOnChangeEnd(
                    val,
                    setEndDateOpen,
                    setSelectedEndDate,
                    setDisplayEndDate,
                    setEndDate
                  );
                }}
                minDate={SelectedStartDate || undefined}
                slotProps={{
                  popper: {
                    placement: "bottom-start",
                    anchorEl: document.querySelector("#datepickerfield"),
                    sx: {
                      zIndex: 1500,
                      fontSize: { xs: "12px", sm: "13px", md: "15px" },
                    },
                  },
                  textField: { style: { display: "none" } },
                }}
              />
            </LocalizationProvider>
          </Grid>

          {/* Add Purchase Button */}
          <Grid
            item
            xs={12}
            sm={4}
            md={3}
            lg={2}
            sx={{
              order: { xs: 1, sm: 2 },
              display: "flex",
              justifyContent: { xs: "flex-end", sm: "flex-start" },
            }}
          >
            <Button
              variant="contained"
              onClick={() => setOpen(true)}
              fullWidth
              sx={{
                height: "40px",
                backgroundColor: "#14008B",
                padding: 0,
                whiteSpace: "nowrap",
                fontSize: { xs: "12px", sm: "13px", md: "15px" },
                marginBottom: "10px",
                fontFamily: "'Montserrat', sans-serif",
              }}
              endIcon={<AddIcon />}
            >
              Add Purchase
            </Button>
          </Grid>
        </Grid>

        <Grid
          item
          xs="auto"
          sx={{
            display: "inline-flex",
            padding: "8px 16px",
            // margin: "8px 8px 0px 0",
            fontWeight: "500",
            backgroundColor: "#CCCCFF",
            borderRadius: "8px",
            marginTop: "20px",
            marginLeft: "15px",
          }}
        >
          <Typography
            component="p"
            sx={{
              display: "flex",
              alignItems: "center",
              marginLeft: "5px",
              color: "#00008B",
              fontSize: { xs: "12px", sm: "13px", md: "15px" },
            }}
          >
            <Typography
              component="span"
              sx={{
                fontWeight: 500,
                fontSize: { xs: "12px", sm: "13px", md: "15px" },
              }}
            >
              Total Bills:&nbsp;&nbsp;&nbsp;
            </Typography>
            <Typography
              component="span"
              sx={{
                fontWeight: "600",
                fontSize: { xs: "12px", sm: "13px", md: "15px" },
              }}
            >
              {numberOfRecords}
            </Typography>
          </Typography>
        </Grid>

        <Grid
          item
          xs="auto"
          sx={{
            display: "inline-flex",
            padding: "8px 16px",
            margin: "8px 8px 0px 0",
            fontWeight: "500",
            backgroundColor: "#CCCCFF",
            borderRadius: "8px",
            ml: "15px",
          }}
        >
          <Typography
            component="p"
            sx={{
              display: "flex",
              alignItems: "center",
              color: "#00008B",
            }}
          >
            <Typography
              component="span"
              sx={{
                fontWeight: 500,
                fontSize: { xs: "12px", sm: "13px", md: "15px" },
              }}
            >
              Total Bills Amount:&nbsp;&nbsp;&nbsp;
            </Typography>
            <Typography
              component="span"
              sx={{
                fontWeight: "600",
                fontSize: { xs: "12px", sm: "13px", md: "15px" },
                marginLeft: "4px",
              }}
            >
              {totalAmount?.toFixed(2)}
            </Typography>
          </Typography>
        </Grid>

        {/* <Divider
          sx={{
            width: "100%",
            mt: 2,
            background: (theme) => theme.palette.primary.main,
          }}
        /> */}

        <Grid container>
          <Grid
            item
            xs={12}
            lg={6}
            sx={{
              display: {
                xs: "none",
                sm: "none",
                md: "none",
                lg: "block",
              },
            }}
          ></Grid>
          <Grid item xs={12} sx={{ mt: 3 }}>
            <PurchaseAccordian purchaseItems={purchaseItems} />
          </Grid>
        </Grid>
        <Grid container sx={{ pt: "10px" }}>
          {/* <Grid item xs={4}>
            <Typography color="primary">
              <strong>Total Items: &nbsp; {numberOfRecords}</strong>
            </Typography>
          </Grid> */}
          <Grid
            item
            xs={12}
            sx={{
              // bgcolor: "red",
              display: "flex",
              justifyContent: "center",
            }}
          >
            {/* <Stack direction="row" justifyContent="space-around" sx={{ mt: 2 }}> */}
            {/* <Pagination
              count={PageSizeCalculate(numberOfRecords, pagination)}
              page={pagination.page}
              onChange={handleChange}
            /> */}
            {/* </Stack> */}
          </Grid>
          {/* <Grid item xs={4}></Grid> */}
        </Grid>

        <PuchaseModal
          open={open}
          setOpen={setOpen}
          getPurchase={() => {
            callbackHandlerGetPurchaseob.getPurchase.callback({
              ...callbackHandlerGetPurchaseob.getPurchase.parameter,
              param: {
                fromDate: startDateFormat,
                toDate: endDate,
                search: "string",
                page: pagination.page,
                pageSize: pagination.pageSize,
              },
            });
          }}
          searchItem={searchItem}
          setSearchItem={setSearchItem}
          purchaseItem={purchaseItem}
          setPurchaseItem={setPurchaseItem}
          payload={payload}
          search={search}
          setSearch={setSearch}
          openSearch={openSearch}
          setOpenSearch={setOpenSearch}
        />
        <PurchaseSearchModal
          openSearch={openSearch}
          setOpenSearch={setOpenSearch}
          searchItem={searchItem}
          purchaseItem={purchaseItem}
          setPurchaseItem={setPurchaseItem}
          search={search}
          setSearch={setSearch}
        />
        {/* <AddCircleIcon
          color="primary"
          onClick={() => {
            setOpen(true);
          }}
          sx={{
            fontSize: "60px",
            cursor: "pointer",
            position: "fixed",
            bottom: "10px",
            right: "10px",
            zIndex: "9999",
          }}
        /> */}
      </Box>
    </>
  );
};

export default Purchase;
